module.exports = __webpack_public_path__ + "4aa887f68ca68c69da962a913ca5a4ce.png";